import * as debounce from 'lodash.debounce';

export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

const debouncedPushEcommerce = debounce(
  (data) => pushEcommerce(data),
  1000
);

export const dataLayerAddToCart = (
  gtmEcommerceItems,
  smEcommerceItems,
  systemId,
  grandTotalNum
) => {
  try {
    pushEcommerce({
      event: 'gtm_add_to_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        itemsAll: smEcommerceItems,
        currency: gtmEcommerceItems[0].currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + v.price * v.quantity,
          0
        ),
        valueAll: grandTotalNum,
        systemId: systemId,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerUpdateCart = (
  gtmEcommerceItems,
  systemId,
  grandTotalNum
) => {
  try {
    pushEcommerce({
      event: 'gtm_update_cart',
      ecommerce: {
        itemsAll: gtmEcommerceItems,
        currency: gtmEcommerceItems[0]?.currency || '',
        valueAll: grandTotalNum,
        systemId: systemId,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmViewCart = (cart) => {
  try {
    pushEcommerce({
      event: 'gtm_view_cart',
      ecommerce: {
        currency: cart.currency,
        value: cart.gtmGrandTotal,
        items: cart.gtmOrderRows,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmAddNewsletterOptIn = (email) => {
  try {
    pushEcommerce({
      event: 'gtm_add_newsletter_opt_in',
      ecommerce: {
        email,
      },
    });
  } catch (e) {
    console.error(e);
  }
};

export const dataLayerGtmCheckoutUpdate = (qliroCustomerInfo, cart) => {
  try {
    const itemsAll = cart.orderRows.map((p) => p.gtmEcommerceItem);
    debouncedPushEcommerce({
      event: 'gtm_checkout_update',
      ecommerce: {
        qliroCustomerInfo,
        itemsAll,
        valueAll: cart.grandTotalNum,
        systemId: cart.systemId,
      },
    });
  } catch (e) {
    console.error(e);
  }
};
